import {AppState} from "../store/AppState";
import {Authentication} from "../../model/Authentication";
import {LogoutCompleted} from "../../model/LogoutCompleted";

function selectAuthentication(state: AppState): Authentication|undefined {
  const { authentication } = state;
  return authentication || undefined;
}
function compareAuthenticationStates(next: AppState, prev: AppState) {
  return next.authentication === prev.authentication;
}

function selectUserId(state: AppState): string | undefined {
  return selectAuthentication(state)?.userId;
}
function selectAuthCompleted(state: AppState): boolean {
  return !!state.authentication || !!state.logoutCompleted || (!!state.errors && state.errors.length > 0);
}
function selectLogoutCompleted(state: AppState): LogoutCompleted|undefined {
  return state.logoutCompleted || undefined;
}

function compareLogoutCompleted(next: AppState, prev: AppState): boolean {
  return next.logoutCompleted === prev.logoutCompleted;
}

function selectAuthenticationIsValidUntil(state: AppState): number | undefined {
  return !!state.authentication?.accessTokenReceived &&
  !!state.authentication?.authnIssued &&
  !!state.authentication?.authnExpires
      ? state.authentication.authnExpires -
      (state.authentication.accessTokenReceived -
          state.authentication.authnIssued)
      : undefined;
}
function compareAuthenticationIsValidUntilStates(
    next: AppState,
    prev: AppState
): boolean {
  return (
      next.authentication?.accessTokenReceived ===
      prev.authentication?.accessTokenReceived &&
      next.authentication?.authnIssued === prev.authentication?.authnIssued &&
      next.authentication?.authnExpires === prev.authentication?.authnExpires
  );
}

const AuthenticationUtils = {
  selectAuthentication,
  compareAuthenticationStates,
  selectAuthCompleted,
  selectLogoutCompleted,
  selectUserId,
  selectAuthenticationIsValidUntil,
  compareAuthenticationIsValidUntilStates,
  compareLogoutCompleted,
};
export default AuthenticationUtils;
